function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-delete-archive-disabled_svg__cls-1{fill:#c9c9c9}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-delete-archive-disabled_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-delete-archive-disabled_svg__cls-1",
  d: "M198.69 59.2v129.54a10.49 10.49 0 01-10.47 10.47H69.16a10.48 10.48 0 01-10.47-10.47V59.2h140m8-8h-156v137.54a18.47 18.47 0 0018.47 18.47h119.06a18.47 18.47 0 0018.47-18.47V51.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#c9c9c9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M83.69 110.21h89v23h-89z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-delete-archive-disabled_svg__cls-1",
  d: "M54.69 55.21h147v31h-147z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-delete-archive-disabled_svg__cls-1",
  d: "M197.69 59.2v23h-139v-23h139m8-8h-155v39h155v-39z"
}));

function SvgIconDeleteArchiveDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 259 259"
  }, props), _ref, _ref2);
}

export default SvgIconDeleteArchiveDisabled;